import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ClarityRouteTracker - Tracks route changes for Microsoft Clarity in React Router SPA
 * This ensures all page views are properly tracked, not just the initial page load
 */
const ClarityRouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if Clarity is loaded
    if (typeof window !== 'undefined' && (window as any).clarity) {
      // Track page view for current route
      (window as any).clarity('set', 'page', location.pathname + location.search);
    }
  }, [location.pathname, location.search]);

  return null; // This component doesn't render anything
};

export default ClarityRouteTracker;

